import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { init, refreshToken } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';
import ModalEditContact from './ModalEditContact';
import TagInputs from './TagInputs';

const NewContact = (props) => {
  
  const toggle = props.toggleSidebar ? '215px' : '10px'
  const [nameContact, setNameContact] = useState('');
  const [lastname, setLastname] = useState('');
  const [celphone, setCelphone] = useState('');
  const [birthday, setBirthday] = useState(null);
  const [start, setStart]= useState(true)

  const [newContact, setNewContact] = useState(false);
  const [contacts, setContacts] = useState([]);
  const {showNotification} = useContext(NotificationContext)
  const [contactSelect, setContactSelect] = useState([]);

  const divGroupsRef = useRef();


  const saveContact = async({nameContact, lastname, celphone, birthday, divGroupsRef, update, contactSelect, btnClose}) => {
    if(nameContact.trim() === '' || lastname.trim() ==='' || celphone === ''){
      showNotification('failed', 'Complete los datos del nuevo contacto...')
      return

    }
    const result = await init();
    if(!result) return window.location.href = '/login'
    try {
      let groups = [];
      let group = false;
      const arrayGroups= divGroupsRef.current.childNodes[1].childNodes
      if(arrayGroups.length > 0) {
        for (const item of arrayGroups) {
          if(item.className === "tag-item"){
            let num = item.textContent.replace('x', '');
            groups.push(num);
          }
        }
      }

      group = groups.length > 0;
      const URL = update ? constants.test_host + '/user/updateclient' : constants.test_host + '/user/createclient';
      const token= window.localStorage.getItem('at');
      const {data} = await axios.post(URL, {name: nameContact, lastname, celphone, birthday, groups, group, contactSelect}, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      showNotification('success', data.message);
      setNameContact('');
      setBirthday(0);
      setCelphone('');
      setLastname('');
      setContacts([]);
      setNewContact(!newContact);
    } catch (error) {
      console.log(error)
      showNotification('failed', error.response.data.error)
    }
  }

  const handleUpdate = (e) => {    
    setStart(false);
    setContactSelect(e.target.offsetParent.id);
  }

  const verifyContacts = () => {
    if(contacts.length === 0) {
      getContacts();
      return
    }
    return
  }

  const getContacts = async() => {

    try {
      const result = await init();
      if(!result) return window.location.href = '/login'
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/user/clients/list';
      const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
      setContacts(data.clients);
      setStart(false);
      
    } catch (error) {
      console.log(error);
      if(error === 401){
        const result = await refreshToken();
        if(result) verifyContacts();
        else {
          window.localStorage.clear();
          return window.location.href = '/login';
        }
      }else {
        window.localStorage.clear();
        return window.location.href = '/login';
      }
    }

      }

  const deleteContact = async(e) => {
    try {
      const result = await init();
      if(!result) return window.location.href = '/login'
      const idClient = e.target.offsetParent.id;
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/user/deleteclient/'+ idClient;
      const {data} = await axios.delete(URL,{headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      showNotification('success', data.message);
      setContacts([]);
      setNewContact(!newContact);
      
    } catch (error) {
      console.log(error.response);
      showNotification('failed', error.response.data.message)
    }
  }

  const tableContacts = contacts.map((item, index) =>
  
    <tr key={item._id}>
      <td>{index + 1}</td>
      <td style={{textAlign: 'justify'}}>{item.name}</td>
      <td style={{textAlign: 'justify'}}>{item.lastname}</td>
      <td style={{textAlign: 'justify'}}>{item.celphone}</td>
      <td id={item._id} style={{textAlign: 'justify'}}><a title='Editar contacto' className='btn-sm btn btn-primary' href="#contactModal" role="button" data-bs-toggle="modal" onClick={(e) => handleUpdate(e)} ><i className="fas fa-user-edit"></i></a> <a title='Eliminar contacto' className='btn-sm btn btn-primary' onClick={(e) => deleteContact(e)}><i className="fas fa-trash-alt"></i></a></td>
    </tr>
)

  useEffect(() =>{
    verifyContacts();
  },[newContact])

  return (
      <div
        className="content-wrapper content"
        style={{ marginLeft: `${toggle}`, transition: "all 0.5s", paddingLeft: '10px'}}
      >
        <div className="container">
          <h5 className='subtitle'>Contactos:</h5>
          <div className="row d-flex justify-content-left">
            <form className="row g-2">
              <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                
                <input
                  type="text"
                  className="form-control"
                  id="nameContact"
                  name='nameContact'
                  required
                  value={nameContact}
                  onChange= {({target}) => setNameContact(target.value.charAt(0).toUpperCase() + target.value.slice(1))}
                  placeholder= 'Nombre del contacto'
                  style={{maxHeight: '40px', fontSize:'smaller'}}
                />
                <label style={{fontSize: 'small'}} htmlFor="nameContact">
                  Nombre
                </label>
              </div>
              <div style={{fontSize: 'medium' , minWidth:'200px'}} className="col form-floating form-outline">
                
                <input
                  type="text"
                  className="form-control"
                  id="lastname"
                  name='lastname'
                  required
                  value={lastname}
                  onChange= {({target}) => setLastname(target.value.charAt(0).toUpperCase() + target.value.slice(1))}
                  placeholder= 'Contact'
                  style={{maxHeight: '40px', fontSize:'smaller'}}
                />
                <label style={{fontSize: 'small'}} htmlFor="lastname">
                  Apellido
                </label>
              </div>

              <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                
                <input
                  type="number"
                  className="form-control"
                  id="celphone"
                  name='celphone'
                  required
                  value={celphone}
                  onChange= {({target}) => setCelphone(target.value)}
                  placeholder= 'celular...'
                  style={{maxHeight: '40px', fontSize:'smaller'}}
                />
                <label style={{fontSize: 'small'}} htmlFor="celphone">
                  Celular
                </label>
              </div>

              <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                
                <input
                  type="date"
                  className="form-control"
                  id="birthday"
                  name='birthday'
                  required
                  value={birthday}
                  onChange= {({target}) => setBirthday(target.value)}
                  placeholder= 'celular...'
                  style={{maxHeight: '50px', fontSize:'smaller'}}
                />
                <label style={{fontSize: 'small'}} htmlFor="birthday">
                  Cumpleaños
                </label>
              </div>
              
              <div ref={divGroupsRef}>
                <p style={{fontSize:'10px', textAlign: 'left', paddingTop:'5px', maxHeight: '2px', paddingRight:'200px'}}>Selección de grupos</p>
                <TagInputs display= {'none'} select={true} start = {start}/>
              </div>
  
              <div className="col-auto">
                <button type='button' onClick={()=> saveContact({nameContact, lastname, celphone, divGroupsRef, update: false, contactSelect: null, btnClose: null})} className="btn btn-sm btn-primary mb-3">
                  Guardar
                </button>
              </div>
            </form>
          </div>
  
          <hr />
  
            <div>
            <h6 style={{textAlign: 'left', paddingLeft:'20px', fontSize:'smaller'}}>Contactos Registrados:</h6>
            <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
              <thead>
                <tr>
                  <th>#Id</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Celular</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {tableContacts}
              </tbody>
            </table>
          </div>
  
        </div>

        <div id="contactModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog">
            <div className='modal-content font-mulish'>
              <ModalEditContact start= {start} saveContact= {saveContact} contactSelect ={contactSelect} setUpdateContact = {setNewContact} contacts={contacts} />
            </div>
          </div>
        </div>

      </div>
    );
}

export default NewContact
